import { PURGE } from 'redux-persist/es/constants';

const initialState = {
  id: null,
  email: '',
  emailConfirm: false,
  firstname: '',
  lastname: '',
  dob: '',
  marketConsent: false,
  sessionStart: null,
  country: '',
  city: '',
  street: '',
  house: '',
  flat: '',
  zip: ''
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'User/SET':
      return {
        ...state,
        id: action.payload?.id,
        language: action.payload?.language,
        email: action.payload?.email,
        emailConfirm: action.payload?.email_confirm,
        firstname: action.payload?.first_name,
        lastname: action.payload?.last_name,
        dob: action.payload?.dob,
        marketConsent: action.payload?.marketing_consent,
        country: action.payload?.country,
        city: action.payload?.city,
        street: action.payload?.street,
        house: action.payload?.house,
        flat: action.payload?.flat,
        zip: action.payload?.zip,
      };
    case 'User/UPDATE': {
      return {
        ...state,
        ...action.payload
      };
    }
    case 'User/SET_MARKET_CONSENT':
      return {
        ...state,
        marketConsent: action.payload
      };
    case 'User/RESET':
      return initialState;
      
    case PURGE:
      return initialState;

    default:
      return state;
  }
};

export default userReducer;
